import { render, staticRenderFns } from "./Multiplication.vue?vue&type=template&id=55a16c9a&scoped=true&"
var script = {}
import style0 from "./Multiplication.vue?vue&type=style&index=0&id=55a16c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a16c9a",
  null
  
)

export default component.exports